(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.innerWidth > 991) return;
    if (sessionStorage.getItem('nudge_shown')) return;
    if (window.location.pathname.indexOf('/collections/') === -1) return;

    sessionStorage.setItem('nudge_shown', '1');

    var firstCard = document.querySelector('.snippet-product-card');
    if (!firstCard) return;

    setTimeout(function () {
      firstCard.classList.add('snippet-product-card--nudge');
    }, 900);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-form"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-store-exclusive-url]').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      var url = btn.getAttribute('data-store-exclusive-url');
      if (url) {
        e.preventDefault();
        window.location.href = url;
      }
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["raffle-cta"] && !Shopify.designMode) return;
  try {
    /*
    Klaviyo's size dropdown filters options by the input text, so after picking a
    size, reopening it shows only that size. Once Klaviyo has handled the click and
    opened the list, clear the text so the full list shows; Klaviyo restores the
    selection on blur.
  */
  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target.closest) return;
    var dropdown = target.closest('.klaviyo-dropdown');
    if (!dropdown || !target.closest('input[role="combobox"], button')) return;
    var input = dropdown.querySelector('input[role="combobox"]');
    if (!input) return;

    var inRaffleForm = Array.prototype.some.call(
      document.querySelectorAll('[data-klaviyo-form-id]'),
      function (trigger) {
        var formId = trigger.getAttribute('data-klaviyo-form-id');
        return formId && input.closest('[data-testid="klaviyo-form-' + formId + '"]');
      }
    );
    if (!inRaffleForm) return;

    setTimeout(function () {
      if (!input.value || input.getAttribute('aria-expanded') !== 'true') return;
      var setValue = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value').set;
      setValue.call(input, '');
      input.dispatchEvent(new Event('input', { bubbles: true }));
    }, 0);
  });

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-klaviyo-form-id]');
    if (!trigger) return;

    var formId = trigger.getAttribute('data-klaviyo-form-id');
    if (!formId) return;

    event.preventDefault();
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', formId]);
  });
  } catch(e) { console.error(e); }
})();

})();
